import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import {
  address,
  blockSpecialCharachters,
  city,
  dose_input,
  GOOGLE_RECAPTCHA_SITE_KEY,
  name_input,
  number_input,
  phoneNumber,
  textareaBox,
  zipCode
} from 'src/app/constant/constant';
import {
  ApiResult, PromiseResult,
} from 'src/app/models/PromiseResult';
import { VerifyUserid_Data } from 'src/app/models/User';
import { UserService } from 'src/app/services/user.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { TraceClassDecorator } from '@sentry/angular';
import { OtpInputComponent } from '../../shared/otp-input/otp-input.component';
import { CountriesService } from 'src/app/services/countries.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';
@Component({
  selector: 'app-verify-userid-patient',
  templateUrl: './verify-userid-patient.component.html',
  styleUrls: [
    './verify-userid-patient.component.css',
    './../login-home/login-home.component.css'
  ]
})

@TraceClassDecorator()
export class VerifyUseridPatientComponent implements OnInit {

  @ViewChild(OtpInputComponent) OTP_Input: OtpInputComponent;


  readonly name_input: RegExp = name_input;
  readonly address: RegExp = address;
  readonly city_input: RegExp = city;
  readonly phoneNumber: RegExp = phoneNumber;
  readonly zipCode: RegExp = zipCode;
  readonly textarea: RegExp = textareaBox;
  readonly dose_input: RegExp = dose_input;
  readonly number_input: RegExp = number_input;
  readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;
  readonly sitekey: string = GOOGLE_RECAPTCHA_SITE_KEY;
  logo_url: string = '';
  slug: string = "";
  provider_id: string = '';
  // formPosting: boolean = false;
  // isPassword: boolean = true;
  // recaptcha_Reset: boolean = false;
  // resendDone = false;
  // recaptcha: any;
  // userPatient: User_Registration = new User_Registration();

  // response: PromiseResult;
  // error: ErrorModel;
  // serverError: ServerError;

  verifyUserid_data: VerifyUserid_Data = new VerifyUserid_Data();


  constructor(
    private readonly userservice: UserService,
    private readonly utilitiesService: UtilitiesService,
    private readonly changeDetector: ChangeDetectorRef,
    private readonly countriesService: CountriesService,
    public readonly router: Router,
    private providerStateService: ProviderStateService
  ) { }

  async ngOnInit(): Promise<void> {
    this.slug = this.providerStateService.getProviderSlug();
    sessionStorage.clear();
    this.provider_id = this.providerStateService.getProviderId();
    this.verifyUserid_data = new VerifyUserid_Data();
    this.verifyUserid_data.userid_data.setCurrentType(true);
    this.verifyUserid_data.recaptchaData.reset();
    await this.getCountries();
    this.logo_url = this.providerStateService.getLogoUrl();
  }

  resolved(captchaResponse: any) {
    this.verifyUserid_data.recaptchaData.recaptcha_value = captchaResponse;
    this.verifyUserid_data.verify_modal.recaptcha = this.verifyUserid_data.recaptchaData.recaptcha_value;
  }

  async otp_resend() {
    this.verifyUserid_data.otp_data.OTP_validate_api.retry = true;
    await this.verifyUserID_validate_or_resend_otp();
  }

  async otpVerifySubmit() {
    this.verifyUserid_data.otp_data.OTP_validate_api.retry = false;
    await this.verifyUserID_validate_or_resend_otp();
  }

  async patientVerifyUserID_Init_Submit() {
    this.verifyUserid_data.recaptchaData.reset();
    await this.patientVerifyUserID_Init();
  }

  set_otp_data(result: PromiseResult) {
    this.verifyUserid_data.otp_data.OTP_validate_api.user_guid = result.data.user_guid;
    this.verifyUserid_data.otp_data.OTP_validate_api.service_id = result.data.service_id;
    this.verifyUserid_data.otp_data.OTP_validate_api.retry_after = new Date(result.data.retry_after);
  }

  async userIdFormSubmit() {
    if (this.verifyUserid_data.userid_data.isPhoneNumber()) {
      this.verifyUserid_data.userid_data.contact_number = this.verifyUserid_data.userid_data.selected_country_data.phone_code + this.verifyUserid_data.userid_data.userid_value;
      this.verifyUserid_data.verify_modal.e_email = this.verifyUserid_data.userid_data.contact_number;
    }
    else {
      this.verifyUserid_data.userid_data.email = this.verifyUserid_data.userid_data.userid_value;
      this.verifyUserid_data.verify_modal.e_email = this.verifyUserid_data.userid_data.userid_value;
    }
    await this.patientVerifyUserID_Init();
  }

  async getCountries(): Promise<void> {
    await this.countriesService
      .getCountries(this.provider_id)
      .toPromise()
      .then((countries) => {
        countries.forEach((ele) => {
          ele["final_phone_code"] = '+' + String(ele.phone_code);
          ele["final_label_string"] = ele.acronym + " (" + '+' + String(ele.phone_code) + ")";
        });
        this.verifyUserid_data.userid_data.country_codes = this.utilitiesService.getSelectItemList(countries, "final_label_string", "final_phone_code");
      }).catch((err) => {
        console.error(err);
      });
  }

  async verifyUserID_validate_or_resend_otp() {
    this.verifyUserid_data.otp_data.otp_api_result = new ApiResult(true);
    await this.userservice
      .verifyUserID_validate_or_resend_otp_patient(this.verifyUserid_data.otp_data.OTP_validate_api)
      .toPromise()
      .then(async (result) => {
        this.verifyUserid_data.otp_data.otp_api_result.PromiseResult = result;
        if (result.success) {
          if (this.verifyUserid_data.otp_data.OTP_validate_api.retry) {
            this.set_otp_data(result);
            this.changeDetector.detectChanges();
            await this.OTP_Input.init_countdown();
          }
          else {
            // this.login_set_data(result);
            sessionStorage.setItem('userid', result.data.userid);
            sessionStorage.setItem('authtoken', result.data.authtoken);
            sessionStorage.setItem('refresh', "true");
            sessionStorage.setItem('refresh_token', result.data.refreshToken);
            sessionStorage.setItem('email', 'default');
            sessionStorage.setItem('name', 'default');
            this.router.navigate(['/' + this.slug + '/patient']);
          }
        }
        this.verifyUserid_data.otp_data.otp_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.verifyUserid_data.otp_data.otp_api_result.ServerError = error.error;
        this.verifyUserid_data.otp_data.otp_api_result.PromiseResult.success = false;
        this.verifyUserid_data.otp_data.otp_api_result.Posting = false;
      })
  }

  async patientVerifyUserID_Init(): Promise<void> {
    this.verifyUserid_data.verify_api_result = new ApiResult(true);
    await this.userservice
      .verifyUserID_Init(this.verifyUserid_data.verify_modal)
      .toPromise()
      .then((result) => {
        this.verifyUserid_data.verify_api_result.PromiseResult = result;
        if (result.success) {
          this.set_otp_data(result);
          this.verifyUserid_data.tabViewData.nextTab(1);
        }
        this.verifyUserid_data.verify_api_result.Posting = false;
      })
      .catch((error: HttpErrorResponse) => {
        this.verifyUserid_data.verify_api_result.ServerError = error.error;
        this.verifyUserid_data.verify_api_result.PromiseResult.success = false;
        this.verifyUserid_data.verify_api_result.Posting = false;
      });
  }

  async openLink(
    base_url_name: string,
    link: string,
    target: string
  ): Promise<void> {
    await this.utilitiesService.openWebsiteLinks(
      base_url_name,
      link,
      target
    );
  }

  isPosting(): boolean {
    return this.verifyUserid_data.verify_api_result.Posting ||
      this.verifyUserid_data.otp_data.otp_api_result.Posting;
  }

}
